import Storage from './Storage';

/**
 * Store OpeningHours
 * 
 */
class OpeningHours extends Storage {
    storeName = 'opening_hours_';
    hasOldKey = true;

    /**
     * OpeningHours constructor
     * 
     * @param {string} id client id
     */
     constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

}

export default OpeningHours;